// extracted by mini-css-extract-plugin
module.exports = {"childContainer":"ConfirmRemoveActions_childContainer__TlE8_","menuContainer":"ConfirmRemoveActions_menuContainer__3_Pay"};